import { Component, Inject, Input, OnInit, Optional, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

export interface ModalConfirmData {
    message?: string;
    submit_color?: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

@Component({
    selector: 'confirm-modal',
    templateUrl: 'confirm-modal.html',
    styleUrls: ['confirm-modal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalConfirmComponent implements OnInit {
    @Input() message;
    @Input() submit_color;
    @Input() confirmLabel;
    @Input() cancelLabel;

    constructor(
        private modal: NzModalRef,
        @Optional() @Inject(NZ_MODAL_DATA) data?: ModalConfirmData
    ) {
        if (data) {
            this.message = data.message ?? this.message;
            this.submit_color = data.submit_color ?? this.submit_color;
            this.confirmLabel = data.confirmLabel ?? this.confirmLabel;
            this.cancelLabel = data.cancelLabel ?? this.cancelLabel;
        }
    }

    ngOnInit() { }

    close(result) {
        this.modal.destroy(result);
    }
}
